import { SidebarItem } from '@shared/sidebaritem';

export const sidebarItems: SidebarItem[] = [
	{
		label: 'Matrices',
		icon: 'acies_matrix',
		path: 'calculations/matrices',
		overlay: false,
		children: [],
		parents: ['Calculations'],
		permission: '',
		forceTranslateKey: 'calculations.sidebar.matrices',
	},
];
